import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PanelTableLoader } from '../../../../PanelTableLoader';
import { SessionInformationProps } from './container';
import { SessionInformationPanelGrid } from './components/SessionInformationPanelGrid/SessionInformationPanelGrid';
import { ApexSessionInformationPanelGrid } from './components/ApexSessionInformationPanelGrid/ApexSessionInformationPanelGrid';

export function SessionInformation({
  isLoading,
  sessionInformation,
  isError,
  isApexDemo,
}: SessionInformationProps): ReactElement {
  const { t } = useTranslation();

  if (!sessionInformation || isLoading || isError) {
    return <PanelTableLoader />;
  }

  return (
    <>
      <div className="base-margin-bottom">
        {t('sessions.panels.info.sessionInformation.heading')}
      </div>

      <ApexSessionInformationPanelGrid
        sessionInformation={sessionInformation}
        isApexDemo={isApexDemo}
      />

      <SessionInformationPanelGrid
        sessionInformation={sessionInformation}
        isApexDemo={isApexDemo}
      />
    </>
  );
}
